"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loaderType = exports.loaderSize = void 0;

/**
 * @desc
 * Size of the loader.
 *
 * @enum
 *
 * @type {{XXS: string, XS: string, SM: string, S: string, M: string, ML: string, L: string}}
 */
var loaderSize = {
  XXS: 'xxs',
  XS: 'xs',
  SM: 'sm',
  S: 's',
  M: 'm',
  ML: 'ml',
  L: 'l'
};
/**
 * @desc
 * Type of the loader.
 *
 * @enum
 *
 * @type {{SIMPLE: string, OVERLAY: string}}
 */

exports.loaderSize = loaderSize;
var loaderType = {
  SIMPLE: 'simple',
  OVERLAY: 'overlay'
};
exports.loaderType = loaderType;
//# sourceMappingURL=constants.js.map